import { GzAntimalwareAntiExploitAppFormWebComponent } from './component/GzAntimalwareAntiExploitAppFormWebComponent';

export { GzAntimalwareAntiExploitAppFormWebComponent };
